export default "__VITE_ASSET__DpmQC__c__"